// client/src/components/StatisticsPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { Box, Button } from '@mui/material';
import AppBarHeader from './AppBarHeader';
import StatisticsDashboard from './StatisticsDashboard';

function StatisticsPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const user = token ? jwtDecode(token) : null;
  const userId = user ? user.id : null;
  const isAdmin = user ? user.isAdmin : false;

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div>
      <AppBarHeader 
        isAdmin={isAdmin} 
        userId={userId} 
        onLogout={handleLogout}
      />
      <Button
        variant="outlined"
        onClick={() => navigate('/admin')}
        sx={{ mb: 2, ml: 2 }}
      >
        ← Back to Admin Dashboard
      </Button>
      <StatisticsDashboard />
    </div>
  );
}

export default StatisticsPage;
